.klarna-homepage-banner {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	> button {
		text-decoration: underline;
		cursor: pointer;
	}
	.logo-wrapper {
		max-height: 40px;
		overflow: hidden;
		margin-left: 5px;
	}
	.klarna-info {
		position: fixed;
		inset: 10%;
		border-radius: 5px;
		z-index: 100;
		overflow: auto;
		&:before {
			content: "";
			position: fixed;
			inset: 0;
			background: rgba(0, 0, 0, 0.5);
		}

		klarna-placement {
			position: relative;
		}

		.close-button {
			position: fixed;
			top: 12%;
			right: 12%;
			background: black;
			color: white;
			font-size: 24px;
			z-index: 1;
			aspect-ratio: 1/1;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 50px;
			cursor: pointer;
		}
	}
}
